export default __webpack_public_path__ + "static/media/facebook.aa070d86.svg";